export class Terminal {
  terminalId?: number = 0;
  practiceId: number;
  name: string;
  apiKey: string;
  keySerialNumber:string;
  //isSandbox: boolean;
  type: string;
  isActive: boolean;
  manufacturer: string;
  modelNo: string;
  installationDate: Date;
  activationDate: Date;
}
